export default __webpack_public_path__ + "static/media/logo.37309cd9.svg";